import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { TransformerSet } from '../../../contexts/RequestsContext/constants';
import { Envelope } from '../../../types';
import { ConstructGet } from '../../types/ConstructGet';
import { NonPaginatedResponse } from '../../types/NonPaginatedResponse';
import { SIGNATURE_BASE_PATH } from '../constants/signatureBasePath';

export const getEnvelope = (
  constructGet: ConstructGet,
  envelopeId: string,
  params?: RequestConfig['params'],
): Promise<NonPaginatedResponse<Envelope> | undefined> =>
  constructGet<NonPaginatedResponse<Envelope>>(
    `${SIGNATURE_BASE_PATH}/envelope/${envelopeId}`,
    { params },
    { transformerSet: TransformerSet.PreserveKeys },
  );
